import { LaneAPI } from '../../../api/datamanager/LaneAPI';

export class LanesCommand {
    get(laneType, edition, successCallback, errorCallback) {

        const apiResult = LaneAPI.list("active", laneType, edition.county);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    getByProvider(successCallback, errorCallback) {
        const apiResult = LaneAPI.listByProvider("active");

        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    save(laneType, edition, lane, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if (undefined === lane.id || 0 === lane.id) {
            apiResult = LaneAPI.create("active", laneType, edition.county, lane);
            successMessage = "Ciclovia criada com sucesso";
        }
        else {
            apiResult = LaneAPI.update("active", laneType, edition.county, lane.id, lane);
            successMessage = "Ciclovia editada com sucesso";
        }
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    saveByProvider(lane, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if (undefined === lane.id || 0 === lane.id) {
            apiResult = LaneAPI.createByProvider("active", lane);
            successMessage = "Micro Mobilidade criada com sucesso";
        }
        else {
            apiResult = LaneAPI.updateByProvider("active", lane.id, lane);
            successMessage = "Micro Mobilidade editada com sucesso";
        }

        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(laneType, edition, laneId, successCallback, errorCallback) {
        const apiResult = LaneAPI.delete("active", laneType, edition.county, laneId);
        apiResult.then(() => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Ciclovia eliminada com sucesso",
                    data: undefined
                };
                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    deleteByProvider(laneId, successCallback, errorCallback) {
        const apiResult = LaneAPI.deleteByProvider("active", laneId);
        apiResult.then(() => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Micro Mobilidade eliminada com sucesso",
                    data: undefined
                };
                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}
